import { EthereumProvider } from '@walletconnect/ethereum-provider';
import IWallet, { IWalletConfig } from '../types';

const WalletConnectV2 = ({ projectId, chainIds }: IWalletConfig): IWallet => {
  let provider: any;

  const getProvider = async () => {
    if (!projectId) {
      throw new Error('Project Id missing for Wallet Connect V2');
    }

    if (!chainIds) {
      throw new Error('Chain Ids missing for Wallet Connect V2');
    }

    if (!provider) {
      provider = await EthereumProvider.init({
        projectId,
        chains: chainIds,
        showQrModal: true,
        methods: ['eth_sendTransaction', 'personal_sign'],
      });
    }

    return provider;
  };

  const isProviderAvailable = (): boolean => {
    // The provider is always available, since it can be injected by us
    return true;
  };

  const isEnabled = async (): Promise<boolean> => {
    const provider = await getProvider();
    return (
      provider.isWalletConnect &&
      provider.connected &&
      provider.accounts.length > 0
    );
  };

  const disconnect = async (provider: any): Promise<void> => {
    await provider.disconnect();
  };

  return { isProviderAvailable, getProvider, isEnabled, disconnect };
};

export default WalletConnectV2;
